import styled from "styled-components";

export const GreyCard = styled.div`
  margin-left: 14px;
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 15px;
`